<template>
  <a11y-dialog
      @dialog-ref="assignDialogRef"
      app-root="#iteration-messages"
      close-button-label="Close"
      dialog-root="#amex-modal-root"
      id="app-dialog"
      :class-names="{document: 'c-modal a11y-modal c-modal--amex c-amex-modal'}"
  >
    <div class="c-modal__wrap c-content">

      <div class="c-amex-modal__head">
        <img src="/themes/childtheme/assets/images/amex.png" alt="">
        <h2>American Express<sup>®</sup> Experiences</h2>
      </div>

      <p>To check ticket availability for American Express<sup>®</sup> Cardmembers, please enter the first four digits of your card
        number (the long number on the front of the card):</p>
      <div class="c-amex-modal__form">
        <form class="c-inline-form" @submit.prevent="">
          <label class="c-inline-form__label u-hidden-visually" for="amexcode">First four digits of AMEX card number</label>
          <input class="c-inline-form__input" type="text" v-model="amexcode" pattern="3[0-9]{3}" maxlength="4" inputmode="numeric" autocomplete="off" id="amexcode">
          <button class="c-inline-form__submit" @click="validate">Validate</button>
        </form>
      </div>
      <p class="u-smallprint">Note: You must pay for your tickets with an American Express<sup>®</sup> Card to
        take advantage of this offer.</p>
      <p class="c-boxout" :class="validationMessageClass" v-if="message">{{ message }}</p>
    </div>

    <template v-slot:title>
      <span v-html="title"></span>
    </template>

    <template v-slot:closeButtonContent>
      <i class="fal fa-times" aria-hidden="true"></i> <span>Close</span>
    </template>

  </a11y-dialog>
</template>

<script>
import {EventBus} from "../event-bus"
import {A11yDialog} from "vue-a11y-dialog"
import sharedSessions from "../mixins/shared-sessions"

export default {
  name: "AmexModal",
  mixins: [sharedSessions],
  components: {
    "a11y-dialog": A11yDialog
  },
  data() {
    return {
      dialog: null,
      message: '',
      status: '',
      title: '',
      isOpen: false,
      amexcode: '',
    }
  },
  computed: {
    validationMessageClass() {
      return {
        'c-boxout--success': this.message && this.status === 'success',
        'c-boxout--error': this.message && this.status === 'error',
      }
    }
  },
  mounted() {
    EventBus.$on('open-modal--amex', this.openDialog)
  },
  methods: {
    assignDialogRef(dialog) {
      this.dialog = dialog;
      this.dialog.on('show', (dialogEl, event) => {
        const modalWrap = dialogEl.querySelector('.c-modal__wrap')
        modalWrap.scrollTo(0, 0)
        document.body.classList.add('modal-open')
        this.isOpen = true

        // add a click event listener when the dialog is displayed
        document.addEventListener('click', this.addModalEvents, true)
        this.$parent.isLoading = false
      });

      this.dialog.on('hide', (dialogEl, event) => {
        const modalWrap = dialogEl.querySelector('.c-modal__wrap')
        modalWrap.scrollTo(0, 0)
        document.body.classList.remove('modal-open')

        // remove the click event listener when the dialog is removed in order for the dialog to keep
        // showing when loading the same modal due to the click handler always being present if
        // left to persist
        document.removeEventListener('click', this.addModalEvents, true)
        this.isOpen = false
        this.$parent.isLoading = false
      });
    },
    addModalEvents(event) {
      if (!event.target.closest('.c-modal--amex')) {
        this.dialog.hide()
      }
    },
    openDialog() {
      this.dialog.show()
    },
    /**
     * Check the validity of the AMEX card entered.
     */
    validate() {
      if (this.amexcode && this.amexcode.match(/3[0-9]{3}/)) {
        const amexPromoCode = 'Amex123'

        this.status = 'success'
        this.message = 'Welcome to American Express® reserved seating'
        this.promoCode(amexPromoCode).then(response => {
          if ("ModeOfSaleId" in response) {
            window.ModeOfSaleId = parseInt(response.ModeOfSaleId)
            window.isLoggedIn = true
            EventBus.$emit('amex-unlocked--success')
            // Fire event to unlock booking button
            const updateBookingButtons = new Event('update-booking-buttons')
            document.dispatchEvent(updateBookingButtons)

            const updateMosEvent = new CustomEvent('update-mode-of-sale', {
              detail: {
                modeOfSaleId: response.ModeOfSaleId,
                callback: data => {
                  if (data.success) {
                    const goToBookingButtonLink = new Event('go-to-booking-button-link')
                    document.dispatchEvent(goToBookingButtonLink)
                    console.log(`ModeOfSaleId: ${response.ModeOfSaleId}`)
                  }
                }
              }
            })

            document.dispatchEvent(updateMosEvent)
          }
        })

        // Close modal after 1 sec after validation
        setTimeout(() => {
          this.dialog.hide()
        }, 1000)

      } else {
        this.status = 'error'
        this.message = 'Sorry, the code entered does not appear to be from a valid AMEX card. Please try again.'
      }
    }
  }
}
</script>

<style scoped>

</style>
